import React from 'react';
import { translate } from '../Services/translation';
import Svg from './Svg';

const PdfButtonCreatePdf = ({ quantity, checkoutUrl }) => {
    return (
        <a className={`buttonv2 buttonv2-highlight buttonv2-small ${quantity > 0 ? '' : 'hide'}`} href={checkoutUrl}>
            <span>{translate('pdfbutton.createpdf')} ({quantity})</span>
            <Svg icon='arrow-right-thin' />
        </a>
    );
}

export default PdfButtonCreatePdf;